/* eslint-disable-for-generated-file */
/**
 * Generated by orval
 * Do not edit manually.
 * Fireknife API
 * OpenAPI spec version: 1.0.0
 */

/**
 * How per-ticket prices are quoted in widget listing screens. gross = price includes fees & taxes (current behavior). net = price excludes fees & taxes; sidebar forces a simple breakdown (subtotal-net + booking fee + processing fee).
 */
export type ShowPriceListingMode = (typeof ShowPriceListingMode)[keyof typeof ShowPriceListingMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShowPriceListingMode = {
    gross: 'gross',
    net: 'net',
} as const;
